export default "__VITE_ASSET__DRJJwF8n__"